import React, { Component } from 'react';
import { Button, ButtonGroup, Col, ControlLabel, Row } from 'react-bootstrap';
import { connect } from 'react-redux';

import Loader from '../../Loader';

class Create extends Component {
	render() {
		let { AppConfig, actions } = this.props;

		let {
			isLoadingAction,

			card_form_isQRCodeEnabled,
		} = AppConfig;

		let requiredSpan = <span style={{ color: 'red' }}>*</span>;

		return (
			<form>
				<Loader loading={isLoadingAction} />
				<Row>
					<Col md={6}>
						<ControlLabel>QR Code {requiredSpan}</ControlLabel>
					</Col>
					<Col md={6}>
						<ButtonGroup>
							<Button
								bsStyle={card_form_isQRCodeEnabled ? 'success' : null}
								disabled={isLoadingAction}
								onClick={() =>
									actions.setValue({
										card_form_isQRCodeEnabled: true,
									})
								}
							>
								Enable{card_form_isQRCodeEnabled && 'd'}
							</Button>
							<Button
								bsStyle={!card_form_isQRCodeEnabled ? 'danger' : null}
								disabled={isLoadingAction}
								onClick={() =>
									actions.setValue({
										card_form_isQRCodeEnabled: false,
									})
								}
							>
								Disable{!card_form_isQRCodeEnabled && 'd'}
							</Button>
						</ButtonGroup>
					</Col>
				</Row>
			</form>
		);
	}
}

function mapStateToProps(state) {
	let { AppConfig } = state;

	return {
		AppConfig,
	};
}

export default connect(mapStateToProps)(Create);



// WEBPACK FOOTER //
// ./components/AppConfig/FormContainer/CardForm.js